<template>
    <div class="staff-form-container">
        <div class="page-header">
            <div class="breadcrumb">ພະນັກງານ / ລາຍຊື່ / <span>{{ isEdit ? 'ແກ້ໄຂຂໍ້ມູນ' : 'ເພີ່ມພະນັກງານໃໝ່' }}</span>
            </div>
            <div class="header-content">
                <h1>{{ isEdit ? 'ແກ້ໄຂຂໍ້ມູນພະນັກງານ' : 'ເພີ່ມຄູອາຈານ ແລະ ພະນັກງານໃໝ່' }}</h1>
            </div>
        </div>

        

        <form @submit.prevent="handleSubmit">
            <div class="form-layout">
                <!-- ສ່ວນເບື້ອງຊ້າຍ: Profile Image -->
                <div class="form-sidebar">
                    <div class="panel avatar-panel">
                        <div class="avatar-wrapper">
                            <div class="avatar-view">
                                <img :src="form.avatar_base64 || require('@/assets/logo.png')"
                                    :class="{ 'is-empty': !form.avatar_base64 }">
                                <button v-if="form.avatar_base64" type="button" class="remove-avatar"
                                    @click="removeAvatar">×</button>
                            </div>
                            <label class="upload-label">
                                <i class="fas fa-camera"></i> ອັບໂຫຼດຮູບພະນັກງານ
                                <input type="file" @change="handleFileUpload" accept="image/*" hidden>
                            </label>
                        </div>

                        <div class="id-section">
                            <div class="form-group" :class="{ 'has-error': errors.teacher_code }">
                                <label>ລະຫັດຄູ <span class="req">*</span></label>
                                <div class="id-input-group">
                                    <input type="text" v-model="form.teacher_code" readonly placeholder="Auto ID"
                                        @input="clearError('teacher_code')">
                                    <button v-if="!isEdit" type="button" @click="generateStaffId" class="refresh-id"
                                        title="ສ້າງລະຫັດໃໝ່">
                                        <i class="fas fa-magic"></i> <span>ສ້າງລະຫັດ</span>
                                    </button>
                                </div>
                                <div class="error-text" v-if="errors.teacher_code">{{ errors.teacher_code }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ສ່ວນເບື້ອງຂວາ: ຂໍ້ມູນລາຍລະອຽດ -->
                <div class="form-main">
                    <div class="tabs-container">
                        <div class="tabs-nav">

                            <button type="button" class="tab-btn" :class="{ active: activeTab === 'personal' }"
                                @click="changeTab('personal')">
                                <i class="fas fa-id-card"></i> ຂໍ້ມູນພະນັກງານ
                                <i v-if="tabStatus.personal" class="fas fa-check-circle tab-complete-icon"></i>
                            </button>
                            <button type="button" class="tab-btn" :class="{ active: activeTab === 'education' }"
                                @click="changeTab('education')">
                                <i class="fas fa-graduation-cap"></i> ປະຫວັດການສຶກສາ
                                <i v-if="tabStatus.education" class="fas fa-check-circle tab-complete-icon"></i>
                            </button>
                            <button type="button" class="tab-btn" :class="{ active: activeTab === 'work' }"
                                @click="changeTab('work')">
                                <i class="fas fa-briefcase"></i> ປະຫວັດການເຮັດວຽກ
                                <i v-if="tabStatus.work" class="fas fa-check-circle tab-complete-icon"></i>
                            </button>
                            <button type="button" class="tab-btn" :class="{ active: activeTab === 'birth' }"
                                @click="changeTab('birth')">
                                <i class="fas fa-map-marker-alt"></i> ທີ່ຢູ່ເກີດ
                                <i v-if="tabStatus.birth" class="fas fa-check-circle tab-complete-icon"></i>
                            </button>
                            <button type="button" class="tab-btn" :class="{ active: activeTab === 'current' }"
                                @click="changeTab('current')">
                                <i class="fas fa-house-user"></i> ທີ່ຢູ່ປະຈຸບັນ
                                <i v-if="tabStatus.current" class="fas fa-check-circle tab-complete-icon"></i>
                            </button>
                            <button type="button" class="tab-btn" :class="{ active: activeTab === 'specialization' }"
                                @click="changeTab('specialization')">
                                <i class="fas fa-award"></i> ວິຊາສະເພາະ
                                <i v-if="tabStatus.specialization" class="fas fa-check-circle tab-complete-icon"></i>
                            </button>
                        </div>

                        <div class="tab-content border-top pt-4">


                            <!-- Tab: ຂໍ້ມູນພະນັກງານ -->
                            <div v-if="activeTab === 'personal'" class="tab-pane">
                                <div class="field-row">
                                    <div class="form-group">
                                        <label>ເພດ</label>
                                        <select v-model="form.Gender">
                                            <option :value="null">-- ເລືອກເພດ --</option>
                                            <option value="ຊ">ຊາຍ</option>
                                            <option value="ຍ">ຍິງ</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label>ສະຖານະ</label>
                                        <select v-model.number="form['Active ']">
                                            <option :value="1">ເປີດໃຊ້ງານ</option>
                                            <option :value="0">ປິດໃຊ້ງານ</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="field-row">
                                    <div class="form-group" :class="{ 'has-error': errors.First_Name }">
                                        <label>ຊື່ <span class="req">*</span></label>
                                        <input type="text" v-model="form.First_Name" placeholder="ປ້ອນຊື່"
                                            @input="clearError('First_Name')">
                                        <div class="error-text" v-if="errors.First_Name">{{ errors.First_Name }}</div>
                                    </div>
                                    <div class="form-group" :class="{ 'has-error': errors.Last_Name }">
                                        <label>ນາມສະກຸນ <span class="req">*</span></label>
                                        <input type="text" v-model="form.Last_Name" placeholder="ປ້ອນນາມສະກຸນ"
                                            @input="clearError('Last_Name')">
                                        <div class="error-text" v-if="errors.Last_Name">{{ errors.Last_Name }}</div>
                                    </div>
                                </div>
                                <div class="field-row">
                                    <div class="form-group">
                                        <label>ເບີໂທລະສັບ</label>
                                        <input type="text" v-model="form.Mobile_number" placeholder="20XXXXXXXX">
                                    </div>
                                    <div class="form-group">
                                        <label>ວັນເດືອນປີເກີດ</label>
                                        <input type="text" v-model="dobText" @input="handleDobInput" placeholder="dd/mm/yyyy" inputmode="numeric" maxlength="10">
                                    </div>
                                </div>
                                <div class="field-row">
                                    <div class="form-group">
                                        <label>ຊົນເຜົ່າ</label>
                                        <input type="text" v-model="form.ethnicity" placeholder="ລາວລຸ່ມ, ມົ້ງ, ...">
                                    </div>
                                </div>
                            </div>

                            <!-- Tab: ປະຫວັດການສຶກສາ -->
                            <div v-if="activeTab === 'education'" class="tab-pane">
                                <div v-for="(edu, index) in form.education_history" :key="index"
                                    class="record-card mb-4">
                                    <div class="record-header">
                                        <h4>ລາຍການທີ {{ index + 1 }}</h4>
                                        <button v-if="form.education_history.length > 1" type="button"
                                            class="btn-remove-text" @click="removeEducation(index)">
                                            <i class="fas fa-trash-alt"></i> ລຶບລາຍການນີ້
                                        </button>
                                    </div>
                                    <div class="field-row">
                                        <div class="form-group">
                                            <label>ລະດັບການສຶກສາ</label>
                                            <div class="input-with-action pointer"
                                                @click="openDegreeModal('education', index)">
                                                <input type="text" :value="edu.level" readonly
                                                    placeholder="ເລືອກລະດັບການສຶກສາ">
                                                <button type="button" class="btn-icon"><i
                                                        class="fas fa-search"></i></button>
                                            </div>
                                        </div>
                                        <div class="form-group"><label>ວິຊາສະເພາະ</label><input type="text"
                                                v-model="edu.major" placeholder="ເຊັ່ນ: ຄູຄະນິດສາດ"></div>
                                    </div>
                                    <div class="field-row">
                                        <div class="form-group"><label>ຈົບຈາກສະຖາບັນ</label><input type="text"
                                                v-model="edu.school" placeholder="ປ້ອນຊື່ສະຖາບັນ"></div>
                                        <div class="form-group"><label>ປີທີ່ຈົບ</label><input type="text"
                                                v-model="edu.year" placeholder="ເຊັ່ນ: 2020"></div>
                                    </div>
                                    <div class="form-group">
                                        <label>ໝາຍເຫດ (ອື່ນໆ)</label>
                                        <input type="text" v-model="edu.remarks" placeholder="...">
                                    </div>
                                </div>
                                <button type="button" class="btn-add-record" @click="addEducation">
                                    <i class="fas fa-plus-circle"></i> ເພີ່ມປະຫວັດການສຶກສາໃໝ່
                                </button>
                            </div>

                            <!-- Tab: ປະຫວັດການເຮັດວຽກ -->
                            <div v-if="activeTab === 'work'" class="tab-pane">
                                <div v-for="(work, index) in form.work_history" :key="index" class="record-card mb-4">
                                    <div class="record-header">
                                        <h4>ລາຍການທີ {{ index + 1 }}</h4>
                                        <button v-if="form.work_history.length > 1" type="button"
                                            class="btn-remove-text" @click="removeWork(index)">
                                            <i class="fas fa-trash-alt"></i> ລຶບລາຍການນີ້
                                        </button>
                                    </div>
                                    <div class="field-row">
                                        <div class="form-group"><label>ສະຖານທີ່ເຮັດວຽກ/ບໍລິສັດ</label><input type="text"
                                                v-model="work.company" placeholder="ປ້ອນຊື່ສະຖານທີ່"></div>
                                        <div class="form-group"><label>ຕຳແໜ່ງ</label><input type="text"
                                                v-model="work.position" placeholder="ເຊັ່ນ: ຄູສອນ, ຫົວໜ້າພາກ..."></div>
                                    </div>
                                    <div class="field-row">
                                        <div class="form-group"><label>ໄລຍະເວລາ/ປີ</label><input type="text"
                                                v-model="work.year" placeholder="ເຊັ່ນ: 2018 - 2022"></div>
                                        <div class="form-group"><label>ໝາຍເຫດ</label><input type="text"
                                                v-model="work.remarks" placeholder="..."></div>
                                    </div>
                                    <div class="form-group">
                                        <label>ລາຍລະອຽດວຽກ</label>

                                        <input type="text" v-model="work.description"
                                            placeholder="ລະບຸໜ້າທີ່ຮັບຜິດຊອບຫຍໍ້...">
                                    </div>
                                </div>
                                <button type="button" class="btn-add-record" @click="addWork">
                                    <i class="fas fa-plus-circle"></i> ເພີ່ມປະຫວັດການເຮັດວຽກໃໝ່
                                </button>
                            </div>

                            <!-- Tab: ທີ່ຢູ່ເກີດ -->
                            <div v-if="activeTab === 'birth'" class="tab-pane">
                                <div class="field-row-3">
                                    <div class="form-group">
                                        <label>ແຂວງເກີດ</label>
                                        <div class="input-with-action pointer"
                                            @click="openLocationModal('province', 'b')">
                                            <input type="text" :value="locationNames.b_province" readonly
                                                placeholder="ເລືອກແຂວງ">
                                            <button type="button" class="btn-icon"><i
                                                    class="fas fa-map-marker-alt"></i></button>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>ເມືອງເກີດ</label>
                                        <div class="input-with-action pointer" :class="{ 'disabled': !form.b_prov_id }"
                                            @click="openLocationModal('district', 'b')">
                                            <input type="text" :value="locationNames.b_district" readonly
                                                placeholder="ເລືອກເມືອງ">
                                            <button type="button" class="btn-icon"><i
                                                    class="fas fa-search"></i></button>
                                        </div>
                                    </div>
                                    <div class="form-group"><label>ບ້ານເກີດ</label><input type="text"
                                            v-model="form.b_village" placeholder="ບ້ານ"></div>
                                </div>
                            </div>

                            <!-- Tab: ທີ່ຢູ່ປະຈຸບັນ -->
                            <div v-if="activeTab === 'current'" class="tab-pane">
                                <div class="tab-actions mb-3">
                                    <button type="button" class="btn-copy" @click="copyBirthToCurrent">
                                        <i class="fas fa-copy"></i> ຄັດລອກຈາກທີ່ຢູ່ເກີດ
                                    </button>
                                </div>
                                <div class="field-row-3">
                                    <div class="form-group">
                                        <label>ແຂວງປັດຈຸບັນ</label>
                                        <div class="input-with-action pointer"
                                            @click="openLocationModal('province', 'cur')">
                                            <input type="text" :value="locationNames.cur_province" readonly
                                                placeholder="ເລືອກແຂວງ">
                                            <button type="button" class="btn-icon"><i
                                                    class="fas fa-map-marker-alt"></i></button>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>ເມືອງປັດຈຸບັນ</label>
                                        <div class="input-with-action pointer" :class="{ 'disabled': !form.cur_prov_id }"
                                            @click="openLocationModal('district', 'cur')">
                                            <input type="text" :value="locationNames.cur_district" readonly
                                                placeholder="ເລືອກເມືອງ">
                                            <button type="button" class="btn-icon"><i
                                                    class="fas fa-search"></i></button>
                                        </div>
                                    </div>
                                    <div class="form-group"><label>ບ້ານປັດຈຸບັນ</label><input type="text"
                                            v-model="form.cur_village" placeholder="ບ້ານ"></div>
                                </div>
                                <div class="form-group">
                                    <label>ທີ່ຢູ່ລະອຽດ</label>
                                    <input type="text" v-model="form.cur_address"
                                        placeholder="ເຮືອນເລກທີ, ໜ່ວຍ, ເສັ້ນທາງ...">
                                </div>
                            </div>

                            <!-- Tab: ວິຊາສະເພາະ -->
                            <div v-if="activeTab === 'specialization'" class="tab-pane">
                                <div class="form-group">
                                    <label>ທ່ານສອນຊັ້ນໃດ</label>
                                    <input type="text" v-model="form.teach_grade" placeholder="ຕົວຢ່າງ: ມ1 - ມ4">
                                </div>

                                <div class="record-card mb-4 mt-4">
                                    <div class="record-header">
                                        <h4><i class="fas fa-user-tie"></i> ວິຊາສະເພາະທີ່ຜ່ານສ້າງຄູ</h4>
                                    </div>
                                    <div class="form-group">
                                        <label>ວິຊາສະເພາະທີ່ຜ່ານສ້າງຄູ ແມ່ນຫຍັງ</label>
                                        <input type="text" v-model="form.spec_teacher_train"
                                            placeholder="ປ້ອນວິຊາສະເພາະ">
                                    </div>
                                    <div class="field-row">
                                        <div class="form-group"><label>ເລີ່ມຮຽນແຕ່ປີໃດ</label><input type="text"
                                                v-model="form.spec_teacher_start" placeholder="2015"></div>
                                        <div class="form-group"><label>ຮຽນຈົບປີໃດ</label><input type="text"
                                                v-model="form.spec_teacher_end" placeholder="2020"></div>
                                    </div>
                                    <div class="form-group">
                                        <label>ລະດັບວິຊາສະເພາະທີ່ຜ່ານສ້າງຄູ (ໃບປະກາດ)</label>
                                        <div class="input-with-action pointer" @click="openDegreeModal('spec_teacher')">
                                            <input type="text" :value="form.spec_teacher_level" readonly
                                                placeholder="ເລືອກລະດັບ">
                                            <button type="button" class="btn-icon"><i
                                                    class="fas fa-search"></i></button>
                                        </div>
                                    </div>
                                </div>

                                <div class="record-card mt-4">
                                    <div class="record-header">
                                        <h4><i class="fas fa-plus-circle"></i> ວິຊາສະເພາະອື່ນໆ</h4>
                                    </div>
                                    <div class="form-group">
                                        <label>ວິຊາສະເພາະອື່ນໆ</label>
                                        <input type="text" v-model="form.spec_other" placeholder="ປ້ອນວິຊາສະເພາະອື່ນໆ">
                                    </div>
                                    <div class="field-row">
                                        <div class="form-group"><label>ເລີ່ມຮຽນແຕ່ປີໃດ</label><input type="text"
                                                v-model="form.spec_other_start" placeholder="2021"></div>
                                        <div class="form-group"><label>ຮຽນຈົບປີໃດ</label><input type="text"
                                                v-model="form.spec_other_end" placeholder="2022"></div>
                                    </div>
                                    <div class="form-group">
                                        <label>ລະດັບວິຊາສະເພາະນີ້ (ໃບປະກາດ)</label>
                                        <div class="input-with-action pointer" @click="openDegreeModal('spec_other')">
                                            <input type="text" :value="form.spec_other_level" readonly
                                                placeholder="ເລືອກລະດັບ">
                                            <button type="button" class="btn-icon"><i
                                                    class="fas fa-search"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ປຸ່ມ Actions ຢູ່ນອກ Tabs ແຕ່ຢູ່ໃນ Form Main -->
                    <div class="form-actions-wrapper mt-4">
                        <button type="button" class="btn-cancel" @click="$router.back()">ຍົກເລີກ</button>
                        <button type="submit" class="btn-save" :disabled="submitting">
                            <i class="fas fa-save"></i> {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກຂໍ້ມູນ' }}
                        </button>
                    </div>
                </div>
            </div>
        </form>

        <!-- Modal ແຈ້ງຜົນຮັບ (Result Modal) -->
        <transition name="modal">
            <div v-if="resultModal.show" class="modal-overlay" @mousedown.self="closeResultModal">
                <div class="custom-modal-card result-modal">
                    <div class="modal-icon" :class="resultModal.type">
                        <i class="fas"
                            :class="resultModal.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'"></i>
                    </div>
                    <div class="modal-content-area">
                        <h2>{{ resultModal.title }}</h2>
                        <p>{{ resultModal.message }}</p>
                    </div>
                    <div class="modal-footer-actions">
                        <button class="btn-modal-primary" :class="resultModal.type" @click="closeResultModal">
                            ເຂົ້າໃຈແລ້ວ
                        </button>
                    </div>
                </div>
            </div>
        </transition>

        <!-- Modal ເລືອກສະຖານທີ່ (Location Picker) -->
        <transition name="modal">
            <div v-if="locationModal.show" class="modal-overlay" @mousedown.self="closeLocationModal">
                <div class="custom-modal-card" role="dialog" aria-modal="true">
                    <div class="custom-modal-header">
                        <h3>{{ locationModal.title }}</h3>
                        <button @click="closeLocationModal" class="close-btn">&times;</button>
                    </div>
                    <div class="custom-modal-search">
                        <div class="input-container">
                            <i class="fas fa-search search-icon"></i>
                            <input type="text" v-model="locationModal.searchQuery" placeholder="ຄົ້ນຫາ..."
                                ref="locationSearchInput">
                        </div>
                    </div>
                    <div class="custom-modal-body">
                        <div v-if="locationModal.loading" class="loading-state">
                            <i class="fas fa-spinner fa-spin"></i> ກຳລັງໂຫຼດ...
                        </div>
                        <div v-else v-for="item in filteredLocationItems" :key="item.id" class="list-item"
                            @click="selectLocationItem(item)">
                            <span class="item-name">{{ item.name }}</span>
                            <i class="fas fa-chevron-right"></i>
                        </div>
                    </div>
                    <div class="custom-modal-footer">
                        <button type="button" class="btn-modal-cancel" @click="closeLocationModal">ຍົກເລີກ</button>
                    </div>
                </div>
            </div>
        </transition>

        <!-- Modal ເລືອກລະດັບການສຶກສາ -->
        <transition name="modal">
            <div v-if="degreeModal.show" class="modal-overlay" @mousedown.self="closeDegreeModal">
                <div class="custom-modal-card" role="dialog" aria-modal="true">
                    <div class="custom-modal-header">
                        <h3>ເລືອກລະດັບການສຶກສາ</h3>
                        <button @click="closeDegreeModal" class="close-btn">&times;</button>
                    </div>
                    <div class="custom-modal-search">
                        <div class="input-container">
                            <i class="fas fa-search search-icon"></i>
                            <input type="text" v-model="degreeModal.searchQuery" placeholder="ຄົ້ນຫາລະດັບການສຶກສາ...">
                        </div>
                    </div>
                    <div class="custom-modal-body">
                        <div v-if="degreeModal.loading" class="loading-state">
                            <i class="fas fa-spinner fa-spin"></i> ກຳລັງໂຫຼດ...
                        </div>
                        <div v-else v-for="item in filteredDegreeItems" :key="item.id" class="list-item"
                            @click="selectDegreeItem(item)">
                            <span class="item-name">{{ item.name }}</span>
                            <i class="fas fa-chevron-right"></i>
                        </div>
                    </div>
                    <div class="custom-modal-footer">
                        <button type="button" class="btn-modal-cancel" @click="closeDegreeModal">ຍົກເລີກ</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import api from '@/utils/api';

export default {
    name: 'StaffFormPage',
    data() {
        return {
            isEdit: false,
            submitting: false,
            activeTab: 'personal',
            dobText: '',
            form: {
                teacher_code: '',
                prov_id: '',
                Gender: 'ຊ',
                First_Name: '',
                Last_Name: '',
                role_id: 6,
                Mobile_number: '',
                dob: '',
                'Active ': 1,
                district_id: '',
                school_id: '',
                avatar_base64: null,
                accd: '2025-2026',
                work_history: [
                    { company: '', position: '', year: '', description: '', remarks: '' }
                ],
                education_history: [
                    { level_id: null, level: '', major: '', school: '', year: '', remarks: '' }
                ],
                // Specialization fields
                teach_grade: '',
                spec_teacher_train: '',
                spec_teacher_start: '',
                spec_teacher_end: '',
                spec_teacher_level: '',
                spec_teacher_level_id: null,
                spec_other: '',
                spec_other_start: '',
                spec_other_end: '',
                spec_other_level: '',
                spec_other_level_id: null,
                b_prov_id: null,
                b_province_name: '',
                b_district_id: null,
                b_district_name: '',
                b_village: '',
                cur_prov_id: null,
                cur_province_name: '',
                cur_district_id: null,
                cur_district_name: '',
                cur_village: '',
                cur_address: ''
            },
            locationNames: {
                b_province: '',
                b_district: '',
                cur_province: '',
                cur_district: ''
            },
            degreeModal: {
                show: false,
                index: null,
                target: 'education',
                loading: false,
                searchQuery: '',
                items: []
            },
            locationModal: {
                show: false,
                title: '',
                type: '', // 'province', 'district'
                target: '', // 'b', 'cur'
                loading: false,
                searchQuery: '',
                items: []
            },
            errors: {},
            resultModal: { show: false, type: 'success', title: '', message: '' },
            user: {},
            permissionState: {},
            permissionRecordId: null
        };
    },
    computed: {
        tabStatus() {
            return {
                school: !!(this.form.prov_id && this.form.district_id && this.form.school_id),
                personal: !!(this.form.First_Name && this.form.Last_Name && this.form.Gender),
                education: this.form.education_history && this.form.education_history.some(e => e.level && e.school),
                work: this.form.work_history && this.form.work_history.some(w => w.company || w.description),
                birth: !!(this.form.b_prov_id && this.form.b_district_id && this.form.b_village),
                current: !!(this.form.cur_prov_id && this.form.cur_district_id && this.form.cur_village && this.form.cur_address),
                specialization: !!(this.form.teach_grade && this.form.spec_teacher_train)
            };
        },
        filteredDegreeItems() {
            if (!this.degreeModal.searchQuery) return this.degreeModal.items;
            const q = this.degreeModal.searchQuery.toLowerCase();
            return this.degreeModal.items.filter(i => i.name.toLowerCase().includes(q));
        },
        filteredLocationItems() {
            if (!this.locationModal.searchQuery) return this.locationModal.items;
            const q = this.locationModal.searchQuery.toLowerCase();
            return this.locationModal.items.filter(i => i.name.toLowerCase().includes(q));
        }
    },
    async created() {
        await this.fetchRolePermissions(this.user.user_level);
        const hasManagePermission = await this.hasBit("staff-new", 1);
        if (!hasManagePermission) {
            this.$router.push({ name: 'Forbidden' });
            return;
        }

    },
    async mounted() {
        // ດຶງຂໍ້ມູນຈາກ user-info ຕາມຄຳແນະນຳ
        this.user = JSON.parse(localStorage.getItem("user-info") || "{}");

        // ກວດສອບສິດການຈັດການ (Manage - Bit 1) ສໍາລັບໂມດູນ staff



        this.form.school_id = this.user.school_id || '';
        this.form.prov_id = this.user.prov_id || '';
        this.form.district_id = this.user.district_id || '';

        const id = this.$route.params.id;
        if (id) {
            this.isEdit = true;
            this.fetchData(id);
            // ເພີ່ມ event listener ສຳລັບປຸ່ມ Escape
            document.addEventListener('keydown', this.handleGlobalKeyDown);
        } else {
            this.generateStaffId();
        }
    },
    methods: {
        disableScroll() {
            document.body.style.overflow = 'hidden';
        },
        enableScroll() {
            document.body.style.overflow = '';
        },
        formatDobForDisplay(iso) {
            if (!iso) return '';
            const [y, m, d] = String(iso).split('-');
            if (!y || !m || !d) return '';
            return `${d}/${m}/${y}`;
        },
        handleDobInput() {
            const digits = this.dobText.replace(/\D/g, '').slice(0, 8);
            let formatted = digits;
            if (digits.length > 4) formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
            else if (digits.length > 2) formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}`;
            this.dobText = formatted;

            if (digits.length === 8) {
                const day = digits.slice(0, 2), month = digits.slice(2, 4), year = digits.slice(4, 8);
                this.form.dob = `${year}-${month}-${day}`;
            } else {
                this.form.dob = '';
            }
        },
        handleGlobalKeyDown(e) {
            if (e.key === 'Escape') {
                if (this.locationModal.show) this.closeLocationModal();
            }
        },
        async generateStaffId() {
            try {
                // ດຶງຂໍ້ມູນພະນັກງານລ້າສຸດເພື່ອມາສ້າງລະຫັດຕໍ່ເນື່ອງ
                const response = await api.get('/staff/all', {
                    params: { limit: 1, school_id: this.user.school_id }
                });

                let nextNum = 1;
                if (response.data.code === 1 && response.data.rows && response.data.rows.length > 0) {
                    const lastId = response.data.rows[0].teacher_code;
                    // ດຶງເອົາສະເພາະຕົວເລກທາງທ້າຍຂອງລະຫັດເກົ່າ (ຕົວຢ່າງ STF20240001 -> 0001)
                    const match = lastId.match(/\d+$/);
                    if (match) {
                        nextNum = parseInt(match[0]) + 1;
                    }
                }

                const year = new Date().getFullYear();
                const seq = nextNum.toString().padStart(4, '0');

                this.form.teacher_code = `3131${year}${seq}`;
                this.clearError('teacher_code');
            } catch (error) {
                console.error('Gen Staff ID Error:', error);
            }
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                if (file.size > 2 * 1024 * 1024) {
                    alert('ຂະໜາດຮູບພາບຕ້ອງບໍ່ເກີນ 2MB');
                    event.target.value = '';
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.form.avatar_base64 = e.target.result;
                };
                reader.readAsDataURL(file);
            } else {
                this.form.avatar_base64 = null;
            }
        },
        removeAvatar() {
            this.form.avatar_base64 = null;
            const fileInput = this.$el.querySelector('input[type="file"]');
            if (fileInput) fileInput.value = '';
        },
        async fetchData(id) {
            try {
                const res = await api.get(`/get/teachers/${id}`);
                if (res.data.code === 1) {
                    const data = res.data.rows;
                    // Migration: ຖ້າຂໍ້ມູນເກົ່າເປັນແບບ Field ດ່ຽວ ໃຫ້ຍ້າຍມາໃສ່ Array
                    if (!data.education_history || !Array.isArray(data.education_history)) {
                        data.education_history = [
                            { level_id: data.level_id || null, level: data.edu_level || '', major: data.edu_major || '', school: data.edu_school || '', year: data.edu_year || '', remarks: '' }
                        ];
                    }
                    if (!data.work_history || !Array.isArray(data.work_history)) {
                        const oldWork = typeof data.work_history === 'string' ? data.work_history : '';
                        data.work_history = [
                            { company: '', position: '', year: '', description: oldWork, remarks: '' }
                        ];
                    }
                    this.form = { ...this.form, ...data };
                    this.dobText = this.formatDobForDisplay(this.form.dob);
                }
                this.populateLocationNames();
            } catch (e) {
                console.error('Error fetching data:', e);
            }
        },
        changeTab(targetTab) {
            if (this.activeTab === targetTab) return;

            // ກວດສອບ Validation ຂອງ Tab ປັດຈຸບັນກ່ອນຈະອະນຸຍາດໃຫ້ປ່ຽນ
            if (this.validateCurrentTab()) {
                this.activeTab = targetTab;
            } else {
                this.showResult('warning', 'ຂໍ້ມູນບໍ່ຄົບຖ້ວນ', 'ກະລຸນາປ້ອນຂໍ້ມູນທີ່ຈຳເປັນໃນແຖບປັດຈຸບັນໃຫ້ຄົບຖ້ວນກ່ອນ');
            }
        },
        validateCurrentTab() {
            const newErrors = { ...this.errors };
            let isValid = true;

            // Validation ພື້ນຖານແຍກຕາມ Tab
            if (this.activeTab === 'school') {
                if (!this.form.teacher_code) {
                    newErrors.teacher_code = 'ກະລຸນາປ້ອນ ຫຼື ສ້າງລະຫັດຄູກ່ອນ';
                    isValid = false;
                }
            } else if (this.activeTab === 'personal') {
                if (!this.form.First_Name) { newErrors.First_Name = 'ກະລຸນາປ້ອນຊື່'; isValid = false; }
                if (!this.form.Last_Name) { newErrors.Last_Name = 'ກະລຸນາປ້ອນນາມສະກຸນ'; isValid = false; }
            }

            this.errors = newErrors;
            return isValid;
        },
        async openLocationModal(type, target) {
            if (type === 'district') {
                const parentId = target === 'cur' ? this.form.cur_prov_id : this.form.b_prov_id;
                if (!parentId) {
                    this.showResult('warning', 'ແຈ້ງເຕືອນ', 'ກະລຸນາເລືອກແຂວງກ່ອນ');
                    return;
                }
            }

            this.locationModal.show = true;
            this.locationModal.type = type;
            this.locationModal.target = target;
            this.locationModal.loading = true;
            this.locationModal.searchQuery = '';
            this.locationModal.title = type === 'province' ? 'ເລືອກແຂວງ' : 'ເລືອກເມືອງ';
            this.disableScroll();

            try {
                let url = type === 'province'
                    ? '/getItems/province/prov_name/prov_id'
                    : `/getItemsCondition/district/district_name_lao/district_id/prov_id/${target === 'cur' ? this.form.cur_prov_id : this.form.b_prov_id}`;

                const res = await api.get(url);
                this.locationModal.items = res.data.map(i => ({ id: i.value, name: i.text }));
            } catch (e) {
                console.error(e);
            } finally {
                this.locationModal.loading = false;
                this.$nextTick(() => this.$refs.locationSearchInput?.focus());
            }
        },
        selectLocationItem(item) {
            const target = this.locationModal.target;
            const type = this.locationModal.type;

            if (type === 'province') {
                this.form[`${target}_prov_id`] = item.id;
                this.form[`${target}_province_name`] = item.name;
                this.locationNames[`${target}_province`] = item.name;
                // Reset district when province changes
                this.form[`${target}_district_id`] = null;
                this.form[`${target}_district_name`] = '';
                this.locationNames[`${target}_district`] = '';
            } else {
                this.form[`${target}_district_id`] = item.id;
                this.form[`${target}_district_name`] = item.name;
                this.locationNames[`${target}_district`] = item.name;
            }
            this.closeLocationModal();
        },
        closeLocationModal() {
            this.locationModal.show = false;
            this.enableScroll();
        },
        copyBirthToCurrent() {
            this.form.cur_prov_id = this.form.b_prov_id;
            this.form.cur_province_name = this.form.b_province_name;
            this.form.cur_district_id = this.form.b_district_id;
            this.form.cur_district_name = this.form.b_district_name;
            this.form.cur_village = this.form.b_village;
            this.locationNames.cur_province = this.locationNames.b_province;
            this.locationNames.cur_district = this.locationNames.b_district;
        },
        async openDegreeModal(target, index = null) {
            this.degreeModal.target = target;
            this.degreeModal.index = index;
            this.degreeModal.show = true;
            this.degreeModal.loading = true;
            this.degreeModal.searchQuery = '';
            this.disableScroll();
            try {
                const res = await api.get('/getItems/educational_eegree/degree_name_lao/degree_id');
                this.degreeModal.items = res.data.map(i => ({ id: i.value, name: i.text }));
            } catch (e) {
                console.error(e);
            } finally {
                this.degreeModal.loading = false;
            }
        },
        selectDegreeItem(item) {
            const target = this.degreeModal.target;
            const index = this.degreeModal.index;

            if (target === 'education' && index !== null) {
                this.form.education_history[index].level = item.name;
                this.form.education_history[index].level_id = item.id;
            } else if (target === 'spec_teacher') {
                this.form.spec_teacher_level = item.name;
                this.form.spec_teacher_level_id = item.id;
            } else if (target === 'spec_other') {
                this.form.spec_other_level = item.name;
                this.form.spec_other_level_id = item.id;
            }
            this.closeDegreeModal();
        },
        closeDegreeModal() {
            this.degreeModal.show = false;
            this.enableScroll();
        },
        addEducation() {
            this.form.education_history.push({ level_id: null, level: '', major: '', school: '', year: '', remarks: '' });
        },
        removeEducation(index) {
            this.form.education_history.splice(index, 1);
        },
        addWork() {
            this.form.work_history.push({ company: '', position: '', year: '', description: '', remarks: '' });
        },
        removeWork(index) {
            this.form.work_history.splice(index, 1);
        },
        validateForm() {
            const newErrors = {};
            if (!this.form.teacher_code) newErrors.teacher_code = 'ກະລຸນາປ້ອນ ຫຼື ສ້າງລະຫັດຄູ';
            if (!this.form.First_Name) newErrors.First_Name = 'ກະລຸນາປ້ອນຊື່';
            if (!this.form.Last_Name) newErrors.Last_Name = 'ກະລຸນາປ້ອນນາມສະກຸນ';

            this.errors = newErrors;
            return Object.keys(newErrors).length === 0;
        },
        clearError(field) {
            if (this.errors[field]) {
                this.$set(this.errors, field, null);
            }
        },
        showResult(type, title, message) {
            this.resultModal = { show: true, type, title, message };
        },
        closeResultModal() {
            this.resultModal.show = false;
            // ຖ້າບັນທຶກສຳເລັດ ໃຫ້ດີດກັບໄປໜ້າລາຍຊື່
            if (this.resultModal.type === 'success') {
                this.$router.push('/home/staff/list');
            }
        },
        async handleSubmit() {
            if (!this.validateForm()) {
                return;
            }

            this.submitting = true;
            try {
                let res;
                if (this.isEdit) {
                    res = await api.put(`/update/teachers/${this.$route.params.id}`, { items: this.form });
                } else {
                    res = await api.post('/insertOne', { items: this.form, table: 'teachers' });
                }

                if (res.data.code === 1) {
                    this.showResult('success', 'ສຳເລັດແລ້ວ', 'ບັນທຶກຂໍ້ມູນພະນັກງານຮຽບຮ້ອຍແລ້ວ');
                } else {
                    this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', res.data.desc || 'ບໍ່ສາມາດບັນທຶກຂໍ້ມູນໄດ້');
                }
            } catch (e) { this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບເຊີເວີໄດ້'); }
            finally { this.submitting = false; }
        },
        async populateLocationNames() {
            try {
                const targets = ['b', 'cur'];

                // ດຶງລາຍຊື່ແຂວງທັງໝົດມາຄັ້ງດຽວເພື່ອຄວາມປະຢັດ (Efficiency)
                let provinceList = [];
                if (this.form.b_prov_id || this.form.cur_prov_id) {
                    const res = await api.get('/getItems/province/prov_name/prov_id');
                    provinceList = res.data;
                }

                for (const t of targets) {
                    const provId = this.form[`${t}_prov_id`];
                    const distId = this.form[`${t}_district_id`];

                    if (provId) {
                        const foundProv = provinceList.find(i => i.value == provId);
                        if (foundProv) {
                            this.locationNames[`${t}_province`] = foundProv.text;
                            if (!this.form[`${t}_province_name`]) this.form[`${t}_province_name`] = foundProv.text;
                        }

                        if (distId) {
                            const distRes = await api.get(`/getItemsCondition/district/district_name_lao/district_id/prov_id/${provId}`);
                            const foundDist = distRes.data.find(i => i.value == distId);
                            if (foundDist) {
                                this.locationNames[`${t}_district`] = foundDist.text;
                                if (!this.form[`${t}_district_name`]) this.form[`${t}_district_name`] = foundDist.text;
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('Error populating names:', error);
                this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', 'ບໍ່ສາມາດດຶງຂໍ້ມູນຊື່ສະຖານທີ່ມາສະແດງຜົນໄດ້');
            }
        },
        async fetchRolePermissions(roleId) {
            this.loadingPermissions = true;
            try {
                const res = await api.get(`/getRowsInt/permissions/role_id/${roleId}`);
                if (res.data && res.data.length > 0) {
                    this.permissionState = res.data[0].permissions || {};
                    this.permissionRecordId = res.data[0]._id;

                } else {
                    // ຫາກບໍ່ພົບຂໍ້ມູນ ໃຫ້ຕັ້ງຄ່າເລີ່ມຕົ້ນ
                    this.permissionRecordId = null;
                    const defaults = {};
                    this.menuGroups.forEach(group => {
                        // ຕັ້ງຄ່າເລີ່ມຕົ້ນໃຫ້ກຸ່ມຫຼັກ
                        defaults[group.id] = roleId === 1 ? 7 : 1;
                        group.items.forEach(item => {
                            // ຖ້າເປັນ Admin ໃຫ້ສິດເຕັມ (7), ຖ້າບໍ່ແມ່ນໃຫ້ສິດເບິ່ງຢ່າງດຽວ (1)
                            defaults[item.id] = roleId === 1 ? 7 : 1;
                        });
                    });
                    this.permissionState = defaults;
                }
            } catch (e) {
                console.error('Fetch permissions error:', e);
            } finally {
                this.loadingPermissions = false;
            }
        },
        hasBit(moduleKey, bit) {
            const val = this.permissionState[moduleKey] || 0;
            return (val & (1 << bit)) !== 0;
        },
    }
};
</script>

<style scoped>
.staff-form-container {
    animation: fadeIn 0.4s ease;
}

.form-layout {
    display: grid;
    grid-template-columns: 300px 1fr;
    gap: 24px;
    margin-top: 10px;
    align-items: start;
}

.avatar-panel {
    padding: 30px 20px;
    text-align: center;
}

.avatar-wrapper {
    margin-bottom: 20px;
}

.avatar-view {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    border: 4px solid var(--lao-light);
    margin: 0 auto 15px;
    position: relative;
    background: #f8fafc;
    overflow: hidden;
}

.avatar-view img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.avatar-view img.is-empty {
    padding: 35px;
    opacity: 0.2;
}

.remove-avatar {
    position: absolute;
    top: 5px;
    right: 5px;
    background: var(--danger);
    color: white;
    border: none;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    cursor: pointer;
    font-weight: bold;
}

.upload-label {
    background: var(--gold);
    color: white;
    padding: 8px 20px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s;
    display: inline-block;
}

.upload-label:hover {
    background: #b08520;
    transform: translateY(-1px);
}

/* Location Picker Style */
.input-with-action {
    position: relative;
    display: flex;
    align-items: center;
}

.input-with-action input {
    padding-right: 40px !important;
    cursor: pointer;
    background: white !important;
}

.btn-icon {
    position: absolute;
    right: 12px;
    background: none;
    border: none;
    color: var(--lao);
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.input-with-action.disabled {
    opacity: 0.6;
    pointer-events: none;
    background: #f8fafc !important;
}

.pointer {
    cursor: pointer;
}

.id-section {
    border-top: 1px solid var(--border);
    padding-top: 20px;
    text-align: left;
}

.id-input-group {
    display: flex;
    align-items: center;
    background: #f1f5f9;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid var(--border);
}

.id-input-group input {
    flex: 1;
    background: transparent;
    border: none !important;
    font-weight: 700;
    color: var(--lao);
    font-family: 'IBM Plex Mono', monospace;
    padding-left: 15px;
}

.id-input-group textarea {
    flex: 1;
    background: transparent;
    border: none !important;
    font-weight: 700;
    color: var(--lao);
    font-family: 'IBM Plex Mono', monospace;
    padding-left: 15px;
}

.refresh-id {
    background: var(--lao-light);
    border: none;
    color: var(--lao);
    padding: 10px 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: 13px;
    transition: 0.2s;
    white-space: nowrap;
}

.refresh-id:hover {
    background: var(--lao);
    color: white;
}

.refresh-id i {
    font-size: 14px;
}

.field-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.field-row-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

.field-row-4 {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    margin-top: 15px;
}

.req {
    color: var(--danger);
}

/* Tabs Styling */
.tabs-container {
    background: #fcfcfc;
    border-radius: 12px;
    overflow: hidden;
}

.tabs-nav {
    display: flex;
    gap: 5px;
    padding: 10px 15px 0;
    background: #f1f5f9;
}

.tab-btn {
    padding: 10px 20px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    border-radius: 8px 8px 0 0;
    transition: 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;
}

.tab-btn i {
    font-size: 14px;
    opacity: 0.7;
}

.tab-btn:hover {
    background: rgba(0, 63, 138, 0.05);
    color: var(--lao);
}

.tab-btn.active {
    background: white;
    color: var(--lao);
    box-shadow: 0 -4px 10px -4px rgba(0, 0, 0, 0.05);
}

.record-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 20px;
}

.record-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    border-bottom: 1px dashed #cbd5e1;
    padding-bottom: 10px;
}

.record-header h4 {
    margin: 0;
    color: var(--text2);
    font-size: 14px;
}

.btn-remove-text {
    background: none;
    border: none;
    color: #ef4444;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;
}

.btn-remove-text:hover {
    color: #dc2626;
    text-decoration: underline;
}

.btn-add-record {
    width: 100%;
    padding: 12px;
    background: white;
    border: 2px dashed var(--lao);
    color: var(--lao);
    border-radius: 10px;
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.2s;
}

.btn-add-record:hover {
    background: var(--lao-light);
    border-style: solid;
    transform: translateY(-1px);
}

.tab-complete-icon {
    font-size: 12px !important;
    color: #10b981;
    margin-left: 4px;
    opacity: 1 !important;
}

.tab-content {
    padding: 20px;
    background: white;
    min-height: 200px;
}

.border-top {
    border-top: 1px solid var(--border);
}

.pt-4 {
    padding-top: 1.5rem;
}

.tab-actions {
    display: flex;
    justify-content: flex-end;
}

.btn-copy {
    background: #f8fafc;
    border: 1.5px solid var(--border);
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    color: var(--lao);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s;
    margin-bottom: 10px;
}

.btn-copy:hover {
    background: var(--lao-light);
    border-color: var(--lao);
    transform: translateY(-1px);
}

.readonly-input {
    background-color: #f8fafc !important;
    cursor: not-allowed;
    color: #64748b;
    border-color: #e2e8f0 !important;
}

.form-group.has-error input,
.form-group.has-error select {
    border-color: var(--danger);
    background-color: #fffafa;
}

.error-text {
    color: var(--danger);
    font-size: 12px;
    margin-top: 5px;
}

.btn-save {
    background: var(--lao);
    color: white;
    padding: 10px 30px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-weight: 600;
}

.btn-cancel {
    background: #e2e8f0;
    padding: 10px 20px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    margin-right: 10px;
}

@media (max-width: 900px) {
    .form-layout {
        grid-template-columns: 1fr;
    }

    .form-sidebar {
        position: static;
        width: 100%;
    }

    .avatar-view {
        width: 140px;
        height: 140px;
    }

    .field-row,
    .field-row-3,
    .field-row-4 {
        grid-template-columns: 1fr;
        gap: 10px;
    }
}

/* Modal Overlay Styling */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    padding: 20px;
}

/* Picker Modal & Result Modal Styles */
.custom-modal-card {
    background: white;
    width: 100%;
    max-width: 480px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    max-height: 80vh;
    overflow: hidden;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
    animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* Result Modal Specific Refinement */
.result-modal {
    padding: 40px 30px;
    max-width: 400px !important;
    text-align: center;
}

.custom-modal-header {
    padding: 20px 24px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.custom-modal-header h3 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--lao);
}

.close-btn {
    background: #f1f5f9;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    cursor: pointer;
    color: #64748b;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-modal-search {
    padding: 16px 24px;
    background: #f8fafc;
    border-bottom: 1px solid #f1f5f9;
}

.custom-modal-search .input-container {
    position: relative;
}

.custom-modal-search .search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
}

.custom-modal-search input {
    width: 100%;
    padding: 10px 10px 10px 40px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    outline: none;
    transition: 0.2s;
}

.custom-modal-search input:focus {
    border-color: var(--lao);
    box-shadow: 0 0 0 3px rgba(0, 63, 138, 0.1);
}

.custom-modal-body {
    flex: 1;
    overflow-y: auto;
    padding: 8px 0;
}

.list-item {
    padding: 14px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: 0.2s;
}

.list-item:hover {
    background: #f0f7ff;
}

.list-item .item-name {
    font-size: 15px;
    color: #334155;
    font-weight: 500;
}

.list-item i {
    color: #cbd5e1;
    font-size: 12px;
}

.custom-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    justify-content: flex-end;
}

.btn-modal-cancel {
    background: white;
    border: 1px solid #e2e8f0;
    padding: 8px 20px;
    border-radius: 8px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: 0.2s;
}

.btn-modal-cancel:hover {
    background: #f8fafc;
    color: #0f172a;
}

.loading-state {
    padding: 40px;
    text-align: center;
    color: #94a3b8;
}

.modal-icon {
    font-size: 64px;
    margin-bottom: 20px;
}

.modal-icon.success {
    color: #10b981;
}

.modal-icon.error {
    color: #ef4444;
}

.modal-content-area h2 {
    margin: 0 0 10px;
    font-size: 1.6rem;
    color: #0f172a;
    font-weight: 800;
}

.modal-content-area p {
    color: #334155;
    font-size: 1.05rem;
    line-height: 1.6;
    margin-bottom: 30px;
    font-weight: 500;
}

.modal-footer-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.btn-modal-primary {
    padding: 12px 24px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    background: var(--lao);
    color: white;
    transition: 0.2s;
    min-width: 140px;
}

.btn-modal-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 63, 138, 0.2);
}

.btn-modal-primary.success {
    background: #10b981;
}

.btn-modal-primary.success:hover {
    background: #059669;
}

.btn-modal-primary.error {
    background: #ef4444;
}

.btn-modal-primary.error:hover {
    background: #dc2626;
}

.btn-modal-secondary {
    padding: 12px 24px;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    background: white;
    color: #475569;
    transition: 0.2s;
    min-width: 120px;
}

.btn-modal-secondary:hover {
    background: #f8fafc;
    color: var(--text1);
}

/* Modal Animation */
.modal-enter-active,
.modal-leave-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-enter,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .custom-modal-card {
    animation: modalIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-leave-active .custom-modal-card {
    animation: modalOut 0.2s ease-in;
}

@keyframes modalIn {
    from {
        opacity: 0;
        transform: scale(0.8) translateY(20px);
    }

    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

@keyframes modalOut {
    from {
        opacity: 1;
        transform: scale(1);
    }

    to {
        opacity: 0;
        transform: scale(0.9);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>